import { render, staticRenderFns } from "./drivingRecord.vue?vue&type=template&id=58b10b43&scoped=true&"
import script from "./drivingRecord.vue?vue&type=script&lang=js&"
export * from "./drivingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b10b43",
  null
  
)

export default component.exports